import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import { App } from '@app/App';
import { ErrorBoundary } from '@app/ErrorBoundary';
import { store } from '@app/store';
import { initTelegram } from '@shared/lib/telegram';
import './app/styles/global.css';

// Must run before React paints so the theme attribute is already set.
initTelegram();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </BrowserRouter>
    </Provider>
  </StrictMode>,
);
